import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { ApplicationEmptyState, BaasicDropdown } from 'core/components';
import { PreviewLayout } from 'core/layouts';
import { PatientMissingDocsEdit } from "application/patient-missing-docs/components";
function PatientMissingDocsPreviewTemplate({ patientMissingDocsPreviewViewStore, t }) {
    const {
        loaderStore,
        item,
        localPatientStore,
        facilityOrderTemplateStores,
        showBackButton,
        goBack,
    } = patientMissingDocsPreviewViewStore;

    return (
        <PreviewLayout className="container container--new-flow" store={patientMissingDocsPreviewViewStore} emptyRenderer={<ApplicationEmptyState />} layoutFooterVisible={false} loading={loaderStore.loading}>
            {item &&
                <React.Fragment>
                     {showBackButton &&
                            <div className='content__header--top is-nested'>
                                <div onClick={() => goBack()} className='u-flex--default type--color--brand u-cursor--pointer'>
                                    <i className="u-icon u-icon--xxsml u-icon--btn-back u-mar--right--tny"></i>
                                    {t('LIST_LAYOUT.BACK_BUTTON')}
                                </div>
                            </div>
                        }
                    <div className='content__header u-mar--bottom--xlrg u-position--rel u-flex--default is-nested'>
                        <div className=' u-flex--primary u-flex--default u-flex--grow--1'>
                            <i className="u-icon u-icon--lrg u-icon--persons u-mar--right--sml"></i>
                            <div className="dropdown--header">
                                <BaasicDropdown 
                                    store={localPatientStore}
                                    placeholder={t('PATIENT_MISSING_DOCS.SEARCH.SEARCH_PATIENT_PLACEHOLDER')}
                                />
                            </div>
                        </div>
                    </div>
                    {
                        (facilityOrderTemplateStores && facilityOrderTemplateStores.length > 0) ?
                            facilityOrderTemplateStores.map(store => {
                                return (
                                    <PatientMissingDocsEdit
                                        key={store.item.id}
                                        patientMissingDocsEditViewStore={store}
                                    />
                                );
                            })
                            :
                            <React.Fragment></React.Fragment>
                    }
                </React.Fragment>
            }
        </PreviewLayout >
    )
}

PatientMissingDocsPreviewTemplate.propTypes = {
    patientMissingDocsPreviewViewStore: PropTypes.object.isRequired,
    t: PropTypes.func
};

export default defaultTemplate(PatientMissingDocsPreviewTemplate);